import { defineMessages } from 'react-intl';

export default defineMessages({
    company: {
        id: 'tfpa.gateway.contacts.Estate/Trust',
        defaultMessage: 'Estate/Trust',
    },
    person: {
        id: 'tfpa.gateway.contacts.Person',
        defaultMessage: 'Person',
    },
    wantToDelete: {
        "id": "tfpatranslation.ConstructionDetails.wantToDelete",
        "defaultMessage": "Warning"
    },
    roofingCancelMessage: {
        "id": "tfpatranslation.ConstructionDetails.cancelMessage",
        "defaultMessage": "Are you sure you want to remove this roofing update?"
    },
    insuredCancelMessage: {
        "id": "tfpatranslation.ConstructionDetails.repairCancelMessage",
        "defaultMessage": "Are you sure you want to remove this item?"
    },
    wantToDeleteRepair: {
        "id": "tfpatranslation.ConstructionDetails.wantToDeleteRepair",
        "defaultMessage": "Remove Repair/Addition"
    },
    yesModal: {
        "id": "tfpatranslation.ConstructionDetails.Yes",
        "defaultMessage": "Yes"
    },
    closeModal: {
        "id": "tfpatranslation.ConstructionDetails.Close",
        "defaultMessage": "Close"
    },
    cancelModal: {
        "id": "tfpatranslation.ConstructionDetails.Cancel",
        "defaultMessage": "Cancel"
    },
    noModal: {
        "id": "tfpatranslation.ConstructionDetails.No",
        "defaultMessage": "No"
    },
    roofingAlert: {
        "id": "tfpatranslation.ConstructionDetails.Roofing Alert",
        "defaultMessage": "Unable to Deselect Roofing Updates"
    },
    alertMessage: {
        "id": "tfpatranslation.ConstructionDetails.Alert Message",
        "defaultMessage": "You must remove all the Roofing Updates records in order to uncheck this box."
    },
    
});